<div id="bg">
  <img src="{{ API_IMAGENS }}backgrounds/{{ 1 }}.jpg" alt="" />
</div>
<div id="login-gcc">
  <form (ngSubmit)="onSubmit()" [formGroup]="form">
    <div class="text-center" style="margin-bottom: 10px">
      <a routerLink="/">
        <img
          src="{{ API_IMAGENS }}logo.png"
          id="img-login-logo"
          class="img-fluid"
        />
      </a>
    </div>

    <div
      *ngIf="error"
      class="alert alert-danger mb-2 mt-1 pb-1 pt-1"
      role="alert"
    >
      Usuário ou senha incorretos!
    </div>
    <h5 *ngIf="!error" class="mb-2 mt-3" style="color: #000" i18n>Sua conta</h5>

    <div class="form-group">
      <div class="input-group">
        <div class="input-group-prepend">
          <span class="input-group-text"><i class="icofont-ui-user"></i></span>
        </div>
        <input
          formControlName="email"
          name="email"
          type="email"
          class="form-control"
        />
      </div>
    </div>
    <div class="form-group">
      <div class="input-group">
        <div class="input-group-prepend">
          <span class="input-group-text"><i class="icofont-key"></i></span>
        </div>
        <input
          formControlName="senha"
          name="senha"
          type="password"
          class="form-control"
        />
      </div>
    </div>
    <div class="text-center">
      <button
        type="submit"
        class="btn btn-primary btn-lg"
        style="width: 80%"
        i18n
      >
        Acessar
      </button>
    </div>
    <div class="text-center boxActions">
      <button
        type="button"
        data-toggle="modal"
        data-target="#recuperaModal"
        class="btn btn-link btn-sm"
        i18n
      >
        Esqueci meu usuário ou senha!
      </button>
      <button
        *ngIf="registroLogin"
        type="button"
        data-toggle="modal"
        data-target="#cadastraModal"
        class="btn btn-link btn-sm"
        i18n
      >
        Seu primeiro acesso? Cadastre-se aqui!
      </button>
      <simple-html
        [whiteSpace]="false"
        [html]="SITE ? SITE.mensagemLogin : ''"
      ></simple-html>
    </div>
  </form>
</div>

<div
  class="modal fade"
  style="z-index: 1059;"
  id="cadastraModal"
  tabindex="-1"
  role="dialog"
  aria-labelledby="cadastraModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" i18n>Cadastro</h5>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="p-2 pb-3">
        <novo-cliente [registro]="true" [cadastroCliente]="true" [lgpdCheck]="true"></novo-cliente>
      </div>
    </div>
  </div>
</div>

<div
  class="modal fade"
  id="recuperaModal"
  tabindex="-1"
  role="dialog"
  aria-labelledby="recuperaModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" i18n>Recupera Acesso</h5>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <form (ngSubmit)="onRecuperaSenha()" [formGroup]="form2">
        <div class="modal-body">
          <div
            *ngIf="error2"
            class="alert alert-danger mb-2 mt-1 pb-1 pt-1"
            role="alert"
            i18n
          >
            Email incorreto!
          </div>
          <div class="form-group">
            <label i18n>Informe seu email:</label>
            <input
              formControlName="email"
              name="email"
              type="email"
              class="form-control"
            />
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn btn-outline-primary" i18n>Recuperar Acesso</button>
          <button
            type="button"
            data-dismiss="modal"
            class="btn btn-primary"
            i18n
          >
            Cancelar
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
